
<div class="flex flex-col justify-center items-center w-full bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6 w-full md:w-1/2 ">
        <!-- Success Header -->
        <h2 class="text-2xl font-semibold text-gray-900 text-center mb-4">Booking Rescheduled Successful</h2>
  
        <!-- Lottie Animation -->
        <div class="flex justify-center">
            <ng-lottie #lotani [options]="lottieConfig" width="300px" height="300px" (animCreated)="handleAnimation($event)">
            </ng-lottie>
        </div>
  
        <!-- Booking Details -->
  
        <div class=" flex w-full justify-between items-center border-b pb-4 mt-4">
            <div class="flex items-center space-x-3 basis-0 " style="flex-grow: 2;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:user"
                    matTooltip="Client Name"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Client Name</div>
                    <div class="text-gray-500 text-sm">{{bookingdata.client_first_name}}&nbsp;{{bookingdata.client_last_name}}</div>
                </div>
            </div>
  
            <div class="flex items-center space-x-3 basis-0" style="flex-grow: 1;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:envelope"
                    matTooltip="Email Address"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Client Email</div>
                    <div class="text-gray-500 text-sm">{{bookingdata.client_email}}</div>
                </div>
            </div>
        </div>
  
        <!-- Booking Time & Date -->
        <div class=" flex w-full justify-between items-center border-b pb-4 mt-4">
            <div class="flex items-center space-x-3 basis-0 " style="flex-grow: 2;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                    matTooltip="Booking Duration"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Booking Duration</div>
                    <div class="text-gray-500 text-sm">{{bookingdata.duration}}&nbsp;minutes</div>
                </div>
            </div>
  
            <div class="flex items-center space-x-3 basis-0" style="flex-grow: 1;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:calendar"
                    matTooltip="Booking Date"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Booking Date</div>
                    <div class="text-gray-500 text-sm">{{bookingdata.appointment_start_time | date: 'yyyy-MM-dd'}} - {{bookingSlotTime}}</div>
                </div>
            </div>
        </div>
  
        <!-- Confirmation Message -->
        <div class="text-center space-y-2 mt-6">
            <p class="text-lg text-gray-700">
                Your booking has been rescheduled successfully.
            </p>
            <p class="text-lg text-gray-700">
                You will be notified via email once your booking is approved.
            </p>
        </div>
        <div class="w-full flex justify-center py-3">
          <button  (click)="loadBookingPage()" mat-raised-button
          color="primary" class="w-1/2" type="submit">
          Book Another Appointment
      </button>
        </div>
    </div>
  </div>
  